<template>
  <div id="type" style="display: block">
    <v-container>
      <v-select
          :id="selectId"
          v-model="valueCode"
          :disabled="inputDisabled"
          :error-messages="errors"
          :items="filterItems()"
          :label="label"
          :loading="loading"
          :rules="rules"
          dense
          hide-details="auto"
          item-text="display"
          item-value="code"
          outlined
          @change="errors = []"
      >
        <template #label>
          {{
            label
          }}<span v-if="required" class="red--text font-weight-bold"
        >*</span
        ></template
        >
      </v-select>
    </v-container>
  </div>
</template>

<script>
/*
const itemSort = (a,b) => {
  return (a.display === b.display ? (a.code === b.code ? 0 : (a.code < b.code ? -1: 1)) : (a.display < b.display ? -1 : 1) )
}
*/

import {eventBus} from "@/main";

export default {
  name: "fhir-coding",
  props: ["label", "path", "binding", "edit", "min", "max", "constraints"],
  data: function () {
    return {
      value: {system: "", code: "", display: ""},
      valueCode: "",
      loading: true,
      errors: [],
      selectedNation: "Ethiopian",
      //error: false,
      items: [],
      loadedData: [],
      nclick: 0,
      selectId: "",
      inputDisabled: false,
      qField: "valueCoding",
    };
  },
  mounted: function () {
  
    if (this.binding === "http://ihris.org/fhir/ValueSet/ihris-job-ethiopia") {
      this.$root.$on("loadedData", (data) => {
        this.items = [];
        this.items = data;
      });
    }
    if (this.binding === "http://ihris.org/fhir/ValueSet/ihris-horizontal-salary-scale-valueset") {
      this.$root.$on("loadedHorizontalSalaryData", (data) => {
        this.items = [];
        this.items = data;
      });
    }

    if (
        this.binding ===
        "http://ihris.org/fhir/ValueSet/ihris-leave-type-valueset"
    ) {
      document.getElementById("type").id = "leave_type";
    }
    if (
        this.binding ===
        "http://ihris.org/fhir/ValueSet/ihris-performance-bi-annual-type-valueset"
    ) {
      document.getElementById("dateTime").id = "dateTime2";
      document.getElementById("type").id = "biannual";
    }
  },
  created: function () {
    this.setupData();
  },
  watch: {
    valueCode: function () {
      let tempValue = this.items.find((item) => item.code === this.valueCode);
      if (
          tempValue &&
          tempValue.system ===
          "http://ihris.org/fhir/CodeSystem/ihris-profession-category-codesystem"
      ) {
        this.$fhirutils
            .expandOnDemand(this.valueCode)
            .then((items) => {
              this.$root.$emit("loadedData", items);
            })
            .catch((err) => {
              console.log(err);
              //this.error = true
              this.errors.push(err.message);
              this.loading = false;
            });
      }

      if(tempValue && tempValue.system ==="http://ihris.org/fhir/CodeSystem/ihris-salary-scale-codesystem"){
        this.$fhirutils
            .expandOnDemandHorizontalSalaryScale(this.valueCode)
            .then((items) => {
              this.$root.$emit("loadedHorizontalSalaryData", items);
            })
            .catch((err) => {
              console.log(err);
              this.errors.push(err.message);
              this.loading = false;
            });
      }

      let leaveTypes = [
        "paternity",
        "sick",
        "mourning",
        "forced",
        "sabbatical",
        "wedding",
        "special",
        "leaveWithoutPay",
        "forced",
        "exam",
        "casual",
        "maternity",
        "medical",
        "wedding",
      ];

      let targetDiv = document.getElementById("sub_type");
      let targetDiv2 = document.getElementById("type");
      let targetDiv3 = document.getElementById("dateTime");
      let targetDiv4 = document.getElementById("dateTime2");
      if (this.items) {
        this.value = this.items.find((item) => item.code === this.valueCode);
        if(this.binding === "http://ihris.org/fhir/ValueSet/ihris-salary-scale-valueset"){
          console.log("object");
        }
        if(this.binding === "http://ihris.org/fhir/ValueSet/ihris-horizontal-salary-scale-valueset"){
          fetch("/fhir/CodeSystem/ihris-horizontal-salary-scale-codesystem",{
            method: "GET",
          }).then(response =>{
            if(response.ok){
              response.json().then(data =>{
               let salary =  data.concept.find(x => x.code === this.value.code)?.property.find(x => x.code === "value")?.valueString
                this.$root.$emit("salaryScaleIsSelected", salary);
            })}})
        }
        if (leaveTypes.includes(this.value.code)) {
          if (targetDiv != null) {
            document.getElementById("sub_type").style.display = "none";
          }
        }
        if (this.value.code == "biannual") {
          if (targetDiv2 != null) {
            document.getElementById("type").style.display = "block";
          }
          if (targetDiv4 != null) {
            document.getElementById("dateTime2").style.display = "none";
          }
          if (targetDiv3 != null) {
            document.getElementById("dateTime").style.display = "none";
          }
        }
        if (this.value.code == "probation") {
          if (targetDiv2 != null) {
            document.getElementById("type").style.display = "none";
          }
          if (targetDiv4 != null) {
            document.getElementById("dateTime2").style.display = "block";
          }
          if (targetDiv3 != null) {
            document.getElementById("dateTime").style.display = "block";
          }
        }
      }
      eventBus.$emit(this.path, this.value.code)
    },
  },
  methods: {
    filterItems: function () {
      if (this.label === "Nationality") {
        return this.items;
      } else {
        return this.items.filter((x) => !x.code.includes("(deactivated)"));
      }
    },
    setupData: function () {
      let params = this.$route.query;
      let fhirId = params.practitioner;
      let binding = this.binding;
      if (
          this.$route.params.questionnaire === "ihris-fulltime-ethiopia" &&
          this.binding === "http://ihris.org/fhir/ValueSet/ihris-job-ethiopia"
      ) {
        this.items = [];
        this.loading = false;
      }
      //check the gender for maternity/paternity leave
      else
        fetch("/fhir/Practitioner/" + fhirId)
            .then((response) => {
              response
                  .json()
                  .then((data) => {
                    if (data.gender === "male") {
                      if (
                          this.binding ===
                          "http://ihris.org/fhir/ValueSet/ihris-leave-sub-type-valueset"
                      ) {
                        document.getElementById("type").id = "sub_type";
                      }
                      if (
                          binding ===
                          "http://ihris.org/fhir/ValueSet/ihris-practitionerrole-education-level"
                      ) {
                        let profile =
                            "http://ihris.org/fhir/StructureDefinition/ihris-basic-education-history";
                        fetch(
                            "/fhir/Basic?_profile=" +
                            profile +
                            "&_content=Practitioner/" +
                            this.$route.query.practitioner
                        ).then((response) => {
                          response.json().then((data) => {
                            if (data.entry) {
                              data.entry.forEach((element) => {
                                this.items.push({
                                  code: element.resource.extension[1].extension[1]
                                      .valueCoding.code,
                                  display:
                                      element.resource.extension[1].extension[1]
                                          .valueCoding.display +
                                      " From (" +
                                      element.resource.extension[1].extension[0]
                                          .valueCoding.display +
                                      ")",
                                });
                              });
                            }
                          });
                        });
                      }

                      this.$fhirutils
                          .expand(binding)
                          .then((items) => {
                            this.items = items;
                            this.loading = false;
                            if (items.find((item) => item.code === "maternity")) {
                              this.$delete(this.items, 5);
                            }
                          })
                          .catch((err) => {
                            console.log(err);
                            this.errors.push(err.message);
                            this.loading = false;
                          });
                    } else if (data.gender === "female") {
                      if (
                          this.binding ===
                          "http://ihris.org/fhir/ValueSet/ihris-leave-sub-type-valueset"
                      ) {
                        document.getElementById("type").id = "sub_type";
                      }

                      if (
                          binding ===
                          "http://ihris.org/fhir/ValueSet/ihris-practitionerrole-education-level"
                      ) {
                        let profile =
                            "http://ihris.org/fhir/StructureDefinition/ihris-basic-education-history";
                        fetch(
                            "/fhir/Basic?_profile=" +
                            profile +
                            "&_content=Practitioner/" +
                            this.$route.query.practitioner
                        ).then((response) => {
                          response.json().then((data) => {
                            if (data.entry) {
                              console.log(data.entry);
                              data.entry.forEach((element) => {
                                this.items.push({
                                  code: element.resource.extension[1].extension[1]
                                      .valueCoding.code,
                                  display:
                                      element.resource.extension[1].extension[1]
                                          .valueCoding.display +
                                      " From (" +
                                      element.resource.extension[1].extension[0]
                                          .valueCoding.display +
                                      ")",
                                });
                              });
                            }
                          });
                        });
                      }
                      this.$fhirutils
                          .expand(binding)
                          .then((items) => {
                            this.items = items;
                            this.loading = false;
                            if (items.find((item) => item.code == "paternity")) {
                              this.$delete(this.items, 8);
                            }
                          })
                          .catch((err) => {
                            console.log(err);
                            //this.error = true
                            this.errors.push(err.message);
                            this.loading = false;
                          });
                    } else
                      this.$fhirutils
                          .expand(binding)
                          .then((items) => {
                            this.items = items;
                            this.loading = false;
                            if (this.items.find((item) => item.code === "ET")) {
                              this.items[0] = this.items[71];
                              this.value = this.items[71];
                              this.valueCode = "ET";
                            }
                          })
                          .catch((err) => {
                            console.log(err);

                            this.errors.push(err.message);
                            this.loading = false;
                          });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
            })
            .catch((err) => {
              console.log(err);
            });

      this.items = [];
    },
  },
  computed: {
    required: function () {
      return this.min > 0;
    },
    rules: function () {
      if (this.required) {
        return [(v) => !!v || this.label + " is required"];
      } else {
        return [];
      }
    },
  },
};
</script>
